export const apartmentsGlobalSettings = {
  header: {
    title: "Globale Einstellungen",
    sub: "Gilt für <strong>{count} Apartment</strong> in Ihrem Konto. | Gilt für <strong>{count} Apartments</strong> in Ihrem Konto.",
    globalChip: "GLOBAL",
  },
  sections: {
    activate: "Buchungsmaschine aktivieren",
    payment: "Wann zahlt der Gast?",
    hold: "Reservierungsdauer",
    request: "Anfragemodus",
    link: "Link zum Teilen",
  },
  motor: {
    activeTitle: "Buchungsmaschine aktiv",
    inactiveTitle: "Buchungsmaschine inaktiv",
    activeDesc: "Gäste können direkt über Ihren Link buchen.",
    inactiveDesc: "Direktbuchungen sind für alle Ihre Apartments deaktiviert.",
    statusOn: "Aktiv",
    statusOff: "Inaktiv",
  },
  payment: {
    onArrival: {
      name: "Zahlung bei Anreise",
      hint: "Kostenlos buchen, bei Ankunft bezahlen.",
    },
    online: {
      name: "Online bezahlen",
      hint: "Zahlung bei Bestätigung der Buchung.",
    },
  },
  common: {
    saving: "Wird gespeichert…",
    onlyOnlineBadge: "Nur Online-Zahlung",
  },
  hold: {
    desc: "Der Kalender ist blockiert, während der Gast die Zahlung abschließt.<br>Zahlt er nicht innerhalb der eingestellten Zeit, wird die <strong>Verfügbarkeit automatisch wieder freigegeben</strong>.",
  },
  units: {
    min: "Min.",
    hour: "Stunde",
    hours: "Stunden",
  },
  request: {
    enabledTitle: "Anfragen aktiv",
    autoTitle: "Automatische Bestätigung",
    enabledDesc: "Der Gast sendet eine Anfrage. Sie bestätigen oder lehnen sie per WhatsApp ab.",
    autoDesc: "Die Buchung wird nach Abschluss der Zahlung automatisch bestätigt.",
    tagControl: "Sie bestimmen, wer bucht",
    tagWhatsapp: "WhatsApp bei neuer Anfrage",
  },
  link: {
    desc: "Derselbe Link für alle Ihre Apartments. Teilen Sie ihn in Ihrer Bio, in Kampagnen oder in automatischen Nachrichten.",
    copyTitle: "Kopieren",
    viewVisitor: "Als Besucher ansehen",
    shareWhatsapp: "Per WhatsApp teilen",
  },
  callout: "Wählen Sie in der Seitenleiste ein Apartment aus, um <strong>Tarife</strong>, <strong>Angebote</strong> und <strong>Gebühren</strong> einzeln festzulegen.",
  savebar: {
    unsaved: "Nicht gespeicherte Änderungen an Reservierungsdauer und Anfragemodus",
    save: "Einstellungen speichern",
  },
  toasts: {
    paymentUpdated: "Zahlungsart aktualisiert.",
    paymentError: "Die Zahlungsart konnte nicht gespeichert werden.",
    saved: "Einstellungen gespeichert.",
    saveError: "Speichern nicht möglich.",
    linkCopied: "Link kopiert.",
    copyError: "Kopieren nicht möglich.",
  },
  share: {
    whatsappText: "Hallo 👋 Hier ist der Link zum Buchen: {link}",
  },
};
